import { render, staticRenderFns } from "./new-evaluation-modal.vue?vue&type=template&id=2f46a671&"
import script from "./new-evaluation-modal.vue?vue&type=script&lang=js&"
export * from "./new-evaluation-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports